import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import Title from "../../components/common/Title";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
// import { message } from "../../redux/actions/toastActions";
// import Loader from "../../components/common/Loader";
// import Breadcrumb from "../../components/common/Breadcrumb";
// import Link from "../../components/common/Link";
import "../../styles/Profile.scss";
// import { Button, Form, Modal, Tab, Tabs } from "react-bootstrap";
import ModalPopup from "../../components/common/Modal";
import BoardNotes from "../../components/Board-Management/BoardNotes";
import BoardFiles from "../../components/Board-Management/BoardFiles";
import Contributions from "../../components/Board-Management/Contributions";
import { Topbar } from "../../components/include/Topbar";
import filterIcon from "../../assets/Icons/filter.svg";
import deleteGif from "../../assets/gifs/delete.gif";
// import fileUploadGif from "../../assets/gifs/fileUpload.gif";
// import { type } from "@testing-library/user-event/dist/type";
import {
  isPermission,
  isRole,
  isRoleType,
  selectAuthGate,
} from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import DeleteModal from "../../components/common/DeleteModal";
import dayjs from "dayjs";
import twiterIcon from "../../assets/Icons/twitter (3) 1.png";
import youtubeIcon from "../../assets/Icons/video 1.png";
import { FaLinkedin, FaFacebook, FaInstagram } from "react-icons/fa";
import { toast } from "sonner";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";
import { getBoardManagementPath } from "../../helpers/uttils";

const ViewMember = () => {
  // const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  // const navigate = useNavigate();
  // const [loader, setLoader] = useState(false);
  // const [matchIds, setMatchIds] = useState([]);
  // const [coinloader, setcoinloader] = useState(false);
  // const [targetlink, setTargetLink] = useState({ type: "", targetLink: "" });
  // const [showModal, setShowModal] = useState(false);
  // const [editIndex, setEditIndex] = useState(null);
  // const [modalFile, setmodalFile] = useState(false);
  // const [cmIds, setCMIds] = useState([]);
  const navigate = useCountryNavigate();
  const [Data, setData] = useState("");
  const [apiloader, setapiloader] = useState(false);
  const [modalData, setModalData] = useState({ platform: "", link: "" });
  const [modalForm, setModalForm] = useState(false);
  const [noteIdToDelete, setNoteIdToDelete] = useState(null);
  const [isloading, setIsloading] = useState(true);
  const [activeTab, setActiveTab] = useState("About");
  const [formdata, setFormdata] = useState({
    name: "",
    designation: "",
    bio: "",
    profile_img: "",
    social_media: [],
    notes: [],
    files: [],
    contribution: [],
    start_date: "",
    end_date: "",
    status: 1,
  });
  const [refresh, setRefresh] = useState(false);
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  // const tabs = ["About", "Notes", "Files", "Contribution"];
  // const tabs = [""];
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  const authGate = useSelector(selectAuthGate);
  console.log("permissions", permissions);
  const countryCode =
    location.state?.countryCode ||
    localStorage.getItem("activeCountryCode") ||
    authGate?.school?.country_code ||
    authGate?.school?.country ||
    authGate?.user?.country_code || // if exists
    "KE";
  const basePath = getBoardManagementPath(countryCode);
  // Determine board management label based on country
  const boardManagementLabel =
    countryCode?.toUpperCase() === "UG"
      ? "School Management Committee"
      : "Board Management";
  const isAccessible =
    role === "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("view_Board_Management") || permissions?.includes("view_School"))) ||
    false;
  const addPermission =
    role === "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Board_Management") || permissions?.includes("edit_School"))) ||
    false;
  const deletePermission =
    role === "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("delete_Board_Management") || permissions?.includes("delete_School"))) ||
    false;
  const mode = localStorage.getItem("mode");
  const schoolId = localStorage.getItem("activeSchoolId");
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const getAddButtonLabel = () => {
    switch (activeTab) {
      case "Notes":
        return "Add Notes";
      case "Files":
        return "Upload File";
      case "Contribution":
        return "Add Contribution";
      default:
        return null;
    }
  };

  const handleAddButtonClick = () => {
    if (activeTab === "Notes") {
      navigate(`${basePath}/add-note`, {
        state: { member_id: params.id, type: "Note", countryCode: countryCode },
      });
    } else if (activeTab === "Files") {
      navigate(`${basePath}/add-file`, {
        state: { member_id: params.id, type: "File", countryCode: countryCode },
      });
    } else if (activeTab === "Contribution") {
      navigate(`${basePath}/add-contribution`, {
        state: {
          member_id: params.id,
          type: "Contribution",
          countryCode: countryCode,
        },
      });
    }
  };
  console.log("Data: ", Data);

  const handleDelete = (id) => {
    if (id && id !== "") {
      setModalData(false);
      setIsloading(true);
      Postdata(HttpService.board_management_remove, {
        id: id,
      }).then((res) => {
        toast.success(res.message);
        console.log("res after delete:", res.message);
        // navigate("/board-management");
        // if (role === "admin") {
        //   if (mode === "view") {
        //     navigate(`admin-school/view/${schoolId}`, {
        //       state: { mainTab: "Board Management" },
        //     });
        //   } else {
        //     navigate("navigation-dashboard");
        //   }
        // } else {
        //   navigate("board-management");
        // }
        // dispatch(message(res.message));
      });
    }
  };

  // const onAddSchool = (event) => {
  //   event.preventDefault();
  //   setLoader(true);

  //   Postdata(HttpService.board_management_add, formdata).then((res) => {
  //     if (res.status === 200) {
  //       navigate("/board-management");
  //     }
  //     dispatch(message(res.message));
  //   });
  //   setLoader(false);
  // };
  // const handleModalSave = () => {
  //   const updated = [...formdata.social_media];
  //   updated[editIndex] = modalData;
  //   setFormdata({ ...formdata, social_media: updated });
  //   setShowModal(false);
  // };

  // const handleStatusChange = () => {
  //   setLoader(true);

  //   Postdata(HttpService.board_management_status, { id: formdata.id, status: formdata.status }).then((res) => {
  //     if (res.status === 200) {
  //       setRefresh(!refresh);

  //     }
  //     dispatch(message(res.message));
  //     setLoader(false);
  //   });
  // }

  async function fetchData(id) {
    const response = await Postdata(HttpService.board_management_show, {
      id: id,
    });
    if (response.status !== 200) {
      // navigate("/board-management");
      if (role === "admin" || role !== "schooladmin") {
        navigate("navigation-dashboard", {
          state: {
            mainTab: boardManagementLabel,
            countryCode: countryCode,
          },
        });
      } else {
        navigate(basePath, {
          state: { countryCode: countryCode },
        });
      }
    }
    console.log("response>>>>>>>>>>>>>>>", response);
    setData(response.data);
    setapiloader(false);
    setFormdata({
      id: params.id,
      name: response.data.name,
      designation: response.data.designation,
      bio: response.data.bio,
      status: response.data.status,
      social_media: response.data.social_media || [],
      start_date: response.data.start_date
        ? response.data.start_date.split("T")[0]
        : "",
      end_date: response.data.end_date
        ? response.data.end_date.split("T")[0]
        : "",
    });
    if (!response.data.end_date) {
      setData({
        ...response.data,
        end_date: "Ongoing",
      });
    }
  }

  useEffect(() => {
    if (params.id) {
      // setapiloader(true);
      fetchData(params.id);
    }
  }, [refresh]);

  useEffect(() => {
    console.log("location.state?.currentTab", location.state?.currentTab);
    // 🟨 Set activeTab from navigation state (if exists)
    if (location.state?.currentTab) {
      setActiveTab(location.state.currentTab);
    }
  }, [location.state?.currentTab]);

  if (!isAccessible) {
    return <Error403Page />;
  }

  // if (loader) {
  //   return <Loader isClass="loader_fullscreen" />
  // }

  return (
    <>
      <ModalPopup
        className="alert-box-popup"
        show={modalForm}
        size="md"
        onHide={() => {
          setModalForm(false);
          setNoteIdToDelete(null);
        }}
        onExited={() => setNoteIdToDelete(null)}
      >
        {/* <i className="mdi mdi-information-outline"></i> */}
        <div className="text-center flex justify-center flex-col items-center gap-3 px-3 ">
          <h3>Delete Member</h3>
          <img src={deleteGif} className="w-[120px] " alt="del" />
          <p className="text-card-body">
            Are you sure you want to delete this member? It will erase all his
            data permanently.
          </p>
          <div className="w-full flex justify-between gap-3 mb-2">
            <button
              className="bg-secondary_main w-full text-white px-4 py-2 rounded-lg whitespace-nowrap"
              onClick={() => {
                handleDelete(noteIdToDelete);
                setModalForm(false);
              }}
            >
              Yes, Delete
            </button>
            <button
              className="button-field-primary"
              onClick={() => setModalForm(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </ModalPopup>

      <Title name={`${boardManagementLabel} - View`} />
      <Topbar title="" />
      <div className="p-6 space-y-6 pr-0">
        {/* Tabs */}
        <div className="flex justify-between flex-wrap gap-y-2">
          {/* Conditional Buttons (not shown on "About") */}
          {activeTab !== "About" && addPermission && role !== "admin" && (
            <div className="flex gap-2">
              <button
                className="bg-primary_main text-white px-4 py-2 rounded-lg whitespace-nowrap"
                onClick={handleAddButtonClick}
              >
                {getAddButtonLabel()}
              </button>
              <div className="bg-white text-black px-[15px] rounded-lg whitespace-nowrap flex items-center cursor-pointer">
                <img src={filterIcon} alt="Filter" />
              </div>
            </div>
          )}
        </div>

        {/* Conditional Tab Content */}

        {activeTab === "About" && (
          <>
            {Data ? (
              <div className="bg-white rounded p-6 ">
                <div className="flex justify-between">
                  <div className="flex gap-3">
                    <div className="flex flex-col items-center justify-center w-24 h-24 rounded-full border-1 border-gray-500 cursor-pointer overflow-hidden">
                      <img
                        src={Data?.profile_img}
                        alt="Preview"
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>
                    <div>
                      <h3 className="font-semibold text-[20px] mb-2 text-gray-800">
                        {Data?.name}
                      </h3>
                      <p className="text-[16px] text-gray-800 mb-2">
                        {Data?.designation}
                      </p>
                      <p className="text-[16px] text-gray-500">
                        {console.log(
                          "formdata.start_date",
                          formdata.start_date,
                        )}
                        {dayjs(Data?.start_date).format("DD MMM YYYY")} -{" "}
                        {Data?.end_date !== "Ongoing"
                          ? dayjs(Data?.end_date).format("DD MMM YYYY")
                          : Data?.end_date}
                      </p>
                    </div>
                  </div>
                  {/* { addPermission ? <button
                  role="switch"
                  aria-checked={Data.status == 1 ? true : false}
                  onClick={() => handleStatusChange(Data.id)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${Data.status ? 'bg-green-500' : 'bg-gray-300'
                    }`}
                >
                  <span
                    className={`inline-block h-[18px] w-[18px] transform rounded-full bg-white transition-transform ${Data.status ? 'translate-x-6' : 'translate-x-[3px]'
                      }`}
                  />
                </button>
                :
                <h3 className="text-sm">{Data.status == 1 ? "🟢" : "🔴"}</h3>} */}
                </div>
                <div className="mt-4">
                  <h3 className="font-semibold text-card-role mb-2 text-gray-800">
                    Bio:
                  </h3>
                  <p className="text-[15px] text-gray-800 mb-2">{Data?.bio}</p>
                </div>

                <div className="mt-4">
                  <h3 className="font-semibold text-card-role mb-2 text-gray-800">
                    Professional Summary:
                  </h3>
                  <p className="text-[15px] text-gray-800 mb-2 break-words w-[1000px]">
                    {Data?.description}
                  </p>
                </div>

                <div className="mt-4">
                  <h3 className="font-semibold text-card-role mb-2 text-gray-800">
                    Social Media:
                  </h3>
                  {Data?.social_media && Data.social_media.length > 0 ? (
                    Data?.social_media.map((link, index) => (
                      <div key={index} className="flex mr-2 mb-2 items-center">
                        {link.includes("twitter.com") && (
                          <img src={twiterIcon} alt="Twitter" />
                        )}
                        {link.includes("youtube.com") && (
                          <img
                            src={youtubeIcon}
                            alt="YouTube"
                            className="text-red-600 text-2xl"
                          />
                        )}
                        {link.includes("linkedin.com") && (
                          <FaLinkedin className="text-blue-700 text-2xl" />
                        )}
                        {link.includes("facebook.com") && (
                          <FaFacebook className="text-blue-600 text-2xl" />
                        )}
                        {link.includes("instagram.com") && (
                          <FaInstagram
                            className="text-white text-2xl rounded-lg"
                            style={{
                              background:
                                "linear-gradient(45deg, #FFDD55, #FF543E, #C837AB)",
                              padding: "2px",
                            }}
                          />
                        )}
                        <a
                          href={link}
                          target="_blank"
                          rel="noreferrer"
                          className="text-blue-600 underline text-sm truncate max-w-[80%] ml-2"
                        >
                          {link}
                        </a>
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-600">
                      No social media links available.
                    </p>
                  )}
                </div>

                {deletePermission && role !== "admin" && (
                  <p
                    className="text-[15px] text-secondary_main font-medium underline mb-2 mt-3 cursor-pointer w-fit"
                    onClick={() => {
                      setNoteIdToDelete(Data._id);
                      setModalForm(true);
                    }}
                  >
                    Delete Member?
                  </p>
                )}
              </div>
            ) : (
              <div className="bg-white rounded p-6 ">
                <div className="w-full flex justify-center">Loading...</div>
              </div>
            )}
            {addPermission && role !== "admin" && (
              <div className="text-center">
                <button
                  className="bg-primary_main text-white px-24 py-3 rounded-lg font-medium hover:bg-purple-700"
                  onClick={() =>
                    navigate(
                      `${basePath}/edit-member/${params.id || Data._id}`,
                      {
                        state: { type: "edit" },
                        countryCode: countryCode,
                      },
                    )
                  }
                >
                  Edit Member
                </button>
              </div>
            )}
            {/* <DeleteModal
              title="Delete Board Member"
              message="Are you sure you want to delete Board Member?
It will erase all the data permanently."
              modalOpenDelete={modalForm}
              setmodalOpenDelete={setModalForm}
              handleDelete={handleDelete} // Don't call it here
              selectedId={noteIdToDelete}
              setSelectedId={setNoteIdToDelete}
              modalOpenDeleteSuccess={modalOpenDeleteSuccess}
              setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
              redirectPage={"Board Management"}
              // redirectUrl={"board-management"}
              redirectUrl={
                mode === "view"
                  ? `admin-school/view/${schoolId}`
                  : role === "admin"
                  ? "navigation-dashboard"
                  : "board-management"
              }
              redirectState={
                role === "admin" ? { mainTab: "Board Management" } : undefined
              }
              module={"Board Member"}
            /> */}
            <DeleteModal
              title={`Delete ${boardManagementLabel} Member`}
              message={`Are you sure you want to delete ${boardManagementLabel} Member?
It will erase all the data permanently.`}
              modalOpenDelete={modalForm}
              setmodalOpenDelete={setModalForm}
              handleDelete={handleDelete}
              selectedId={noteIdToDelete}
              setSelectedId={setNoteIdToDelete}
              modalOpenDeleteSuccess={modalOpenDeleteSuccess}
              setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
              redirectPage={boardManagementLabel}
              redirectUrl={
                mode === "view"
                  ? `admin-school/view/${schoolId}`
                  : role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin"
                    ? "navigation-dashboard"
                    : basePath
              }
              redirectState={
                role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin"
                  ? {
                    mainTab: boardManagementLabel,
                    countryCode: countryCode,
                  }
                  : { countryCode: countryCode }
              }
              module={`${boardManagementLabel} Member`}
            />
          </>
        )}

        {activeTab === "Notes" && (
          <>
            <BoardNotes boardMemberId={params.id} />
          </>
        )}

        {activeTab === "Files" && (
          <>
            <BoardFiles boardMemberId={params.id} />
          </>
        )}

        {activeTab === "Contribution" && (
          <>
            <Contributions boardMemberId={params.id} />
          </>
        )}
      </div>
    </>
  );
};

export default ViewMember;
